import Event from 'src/models/Event';
import { useState } from 'react';
import Navigation from 'src/models/Navigation';
import FeaturedEventsSlider from 'src/components/organisms/FeaturedEventsSlider';
import { hideIfOverflowScreen } from 'src/helpers/eventListHelpers';
import EventSearch from 'src/services/EventSearch';
import { useRouter } from 'src/hooks/useRouter';
import { usePluginConfig } from '../../../contexts/pluginContext';

/*
 * This component is responsible for rendering the featured events section
 * it includes both the featured events and the editors picks section (which is a special type of featured event)
 */
const FeaturedEventsSection = ({ rawFeaturedEvents, rawEditorsPickEvents, category }) => {
  const router = useRouter();
  const pluginConfig = usePluginConfig();
  const publisherSettings = pluginConfig.publisherSettings;
  const eventSearch = new EventSearch({ context: router, pluginConfig });
  const isEditorsPicksSection = new Navigation(pluginConfig).lookupBySlug(category)?.id === -1;

  const baseFeaturedEvents = rawFeaturedEvents.map(
    (event) => new Event(event, publisherSettings)
  );
  const baseEditorsPickEvents = (rawEditorsPickEvents || []).map(
    (event) => new Event(event, publisherSettings)
  );

  const [featuredEvents, setFeaturedEvents] = useState(baseFeaturedEvents);
  const [editorsPickEvents, setEditorsPickEvents] = useState(baseEditorsPickEvents);
  const [featuredEventsFullyLoaded, setFeaturedEventsFullyLoaded] = useState(false);
  const [editorsPickEventsFullyLoaded, setEditorsPickEventsFullyLoaded] = useState(false);

  const loadAllFeatured = async () => {
    if (featuredEventsFullyLoaded) {
      return;
    }

    const rawEvents = await eventSearch.allFeaturedEvents(rawFeaturedEvents);
    setFeaturedEvents(rawEvents.map((event) => new Event(event, publisherSettings)));
    setFeaturedEventsFullyLoaded(true);
  };

  const loadAllEditorsPicks = async () => {
    if (editorsPickEventsFullyLoaded) {
      return;
    }

    const rawEvents = await eventSearch.allEditorsPickEvents();
    setEditorsPickEvents(rawEvents.map((event) => new Event(event, publisherSettings)));
    setEditorsPickEventsFullyLoaded(true);
  };

  return (
    <>
      {!isEditorsPicksSection && (
        <>
          {!!editorsPickEvents.length && (
            <FeaturedEventsSlider
              featuredEvents={editorsPickEvents}
              loadAllFeatured={loadAllEditorsPicks}
              publisherSettings={publisherSettings}
              featuredEventsFullyLoaded={editorsPickEventsFullyLoaded}
              heading="editors_pick_heading_text"
            />
          )}
          {!!featuredEvents.length && (
            <div className={hideIfOverflowScreen(featuredEvents.length)}>
              <FeaturedEventsSlider
                featuredEvents={featuredEvents}
                loadAllFeatured={loadAllFeatured}
                publisherSettings={publisherSettings}
                featuredEventsFullyLoaded={featuredEventsFullyLoaded}
                heading="featured_events_heading_text"
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default FeaturedEventsSection;
